import React, { useMemo, useState, useCallback } from 'react';
import { Handle, Position, useNodeConnections, useConnection } from '@xyflow/react';
import { useHistory } from 'react-router';
import { Trans } from '@lingui/react/macro';

import DefaultHandles from './handles/DefaultHandles';
import Icon from 'src/components/Icon';

const NODE_SIZE = {
  width: 200,
  height: 200,
};

function DirectedGraphItemNode(props) {
  const {
    id,
    positionAbsoluteX: x,
    positionAbsoluteY: y,
    width,
    height,
    selected,
    data: { label, isCollapsable, editRoute, const_types },
    isConnectable,
    type,
  } = props;

  const foreignObjectProps = { width, height, x: -100 };

  const history = useHistory();

  const [isCollapsed, setIsCollapsed] = useState(false);

  const children = useNodeConnections({
    id,
    handleType: 'source',
  });

  const onClickEdit = () => {
    history.push(editRoute.replace('$id', id));
  };

  const toggleCollapse = () => setIsCollapsed(!isCollapsed);

  return (
    <div>
      <g className="organizational-unit-tree-node">
        <foreignobject {...foreignObjectProps}>
          <div>
            {const_types ? <div className="type">{const_types[type]}</div> : null}
            <div className="body">
              <h3>{label}</h3>
            </div>
            <div className="buttons">
              {isCollapsable && children?.length ? (
                <button className="btn btn-secondary" onClick={toggleCollapse}>
                  {isCollapsed ? <Icon icon="CaretRight" /> : <Icon icon="CaretDown" />}
                </button>
              ) : null}
              <button className="btn btn-primary" onClick={onClickEdit}>
                <Trans>Edit</Trans>
              </button>
            </div>
          </div>
        </foreignobject>
      </g>
      <DefaultHandles id={id} width={width} height={height} isConnectable={isConnectable} />
    </div>
  );
}

export default DirectedGraphItemNode;
